<template>
  <page-header
    title-ch="最新消息"
    title-en="NEWS!"
    :breadcrumb-items="currentBreadcrumbItems"
    :title-divider="titleDivider"
  >
    <div class="paper_plane first" />
    <div class="paper_plane second" />
    <div class="paper_plane third" />
  </page-header>
</template>
<script>
import PageHeader from '~components/pages/Header'
export default {
  name: 'NewsHeader',
  components: {
    PageHeader
  },
  props: {
    newsType: {
      type: String,
      default: ''
    },
    titleDivider: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      newsBreadcrumb: [
        {
          text: '首頁',
          path: '/'
        },
        {
          text: '最新消息',
          path: '/news'
        }
      ]
    }
  },
  computed: {
    currentBreadcrumbItems () {
      return this.newsType ? this.newsBreadcrumb.concat({
        text: this.newsType
      }) : []
    }
  }
}
</script>
